import { useEffect, useState } from 'react';
import { LIIINGO_HELP_URL } from '../../util/constants';
import { AppBar } from './AppBar';
import { LeftNavProps } from './LeftNav';

export const Nav = (props: LeftNavProps) => {
	const { isHidden } = props;
	const [items, setItems] = useState([]);

	// useEffect to set the appBarItems
	useEffect(() => {
		let baseItems = [{ route: 'dashboard', displayName: 'Dashboard' }];
		let withHelp = [...baseItems, { route: LIIINGO_HELP_URL, displayName: 'Help' }];

		// Always show the help menu since plans are no longer used
		setItems(withHelp);
	}, []);

	if (isHidden) {
		return null;
	}

	return (
		<div>
			<AppBar isHidden={isHidden} appBarItems={items} />
		</div>
	);
};
